import { apiUrl } from '../config/supabase';

// الجداول (user_activity_logs / employee_sessions) مقفولة عن الجمهور —
// فيها بيانات عملاء/موظفين. الكتابة كلها بتعدي على السيرفر (مفتاح الخدمة).
const empToken = () => { try { return localStorage.getItem('emp_token') || ''; } catch { return ''; } };

const postJSON = async (path, body) => {
  return fetch(apiUrl(path), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};

// ── تسجيل نشاط العميل/الزائر (مفتوح — مفيش توكن للزائر) ───────────
export const logUserActivity = async ({
  customerId, customerName, customerEmail,
  action, entityType = null, entityId = null, entityName = null,
}) => {
  try {
    await postJSON('/api/log/user', {
      entry: {
        customer_id:    customerId   || null,
        customer_name:  customerName || 'زائر',
        customer_email: customerEmail || null,
        action,
        entity_type: entityType,
        entity_id:   entityId   || null,
        entity_name: entityName || null,
        user_agent:  navigator.userAgent.substring(0, 250),
      },
    });
  } catch {
    // Silent fail — اللوجينج ما يوقفش التطبيق
  }
};

// ── تسجيل نشاط الموظف (توكن موظف) ────────────────────────────────
export const logEmployeeActivity = async ({
  employeeId, employeeName, employeeRole,
  action, entityType = null, entityName = null,
}) => {
  try {
    await postJSON('/api/admin/session-log', {
      token: empToken(),
      entry: {
        employee_id:   employeeId   || null,
        employee_name: employeeName || 'موظف',
        employee_role: employeeRole || null,
        action,
        entity_type: entityType,
        entity_name: entityName || null,
        session_start: new Date().toISOString(),
      },
    });
  } catch {
    // Silent fail
  }
};

// ── تسجيل خروج الموظف (السيرفر بيقفل آخر جلسة + يسجّل logout) ──────
export const logEmployeeLogout = async (/* employeeId — السيرفر بياخده من التوكن */) => {
  try {
    await postJSON('/api/admin/session-logout', { token: empToken() });
  } catch {
    // Silent fail
  }
};

// ── أسماء الأكشن بالعربي (للتقارير) ──────────────────────────
export const ACTION_LABELS = {
  // User
  login:             '🔑 تسجيل دخول',
  logout:            '🚪 تسجيل خروج',
  register:          '📝 تسجيل جديد',
  view_course:       '👁 مشاهدة كورس',
  view_lesson:       '▶ مشاهدة حلقة',
  payment_start:     '💳 بدء الدفع',
  payment_complete:  '✅ إتمام الدفع',
  // Employee
  add_course:        '➕ إضافة كورس',
  edit_course:       '✏️ تعديل كورس',
  delete_course:     '🗑 حذف كورس',
  add_lesson:        '➕ إضافة حلقة',
  edit_lesson:       '✏️ تعديل حلقة',
  delete_lesson:     '🗑 حذف حلقة',
  approve_payment:   '✅ قبول دفع',
  reject_payment:    '❌ رفض دفع',
  add_employee:      '👤 إضافة موظف',
  edit_employee:     '✏️ تعديل موظف',
  delete_employee:   '🗑 حذف موظف',
  add_coupon:        '🎟 إضافة كوبون',
  edit_coupon:       '✏️ تعديل كوبون',
  delete_coupon:     '🗑 حذف كوبون',
  view_reports:      '📊 فتح التقارير',
  edit_settings:     '⚙️ تعديل الإعدادات',
};
